import { render, staticRenderFns } from "./BuyCard.vue?vue&type=template&id=a506c558&scoped=true&"
import script from "./BuyCard.vue?vue&type=script&lang=js&"
export * from "./BuyCard.vue?vue&type=script&lang=js&"
import style0 from "./BuyCard.vue?vue&type=style&index=0&id=a506c558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a506c558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VCarousel,VCarouselItem,VContainer,VDivider,VImg,VTextField})
